/** @module api/custom_events */

import { apiCall } from '@/api/index'
import {
  apiV1EnergyManagementSystemCustomEventPath,
  apiV1EnergyManagementSystemCustomEventsPath
} from '@/../lib/routes'

export function createCustomEvent({ ctxt, emsId, t, tEnd, label, description }) {
  return apiCall({
    method: 'POST',
    path: apiV1EnergyManagementSystemCustomEventsPath(ctxt, emsId),
    payload: {
      data: {
        id: null,
        type: 'custom_events',
        attributes: {
          t,
          tEnd,
          label,
          description
        }
      }
    }
  })
}

export function deleteCustomEvent({ ctxt, emsId, id }) {
  return apiCall({
    method: 'DELETE',
    path: apiV1EnergyManagementSystemCustomEventPath(ctxt, emsId, id),
    payload: {}
  })
}

export function getCustomEventsForEms({ ctxt, emsId }) {
  return apiCall({
    path: apiV1EnergyManagementSystemCustomEventsPath(ctxt, emsId),
    payload: {}
  })
}
